/* eslint-disable @typescript-eslint/no-explicit-any */
export function setProp<Rec, Path extends null | string, Value>(
  record: Rec,
  path: Path,
  value: Value,
): TSetPropAtStringPath<Rec, Path, Value>

export function setProp<Rec, Path extends string[], Value>(
  record: Rec,
  path: Path,
  value: Value,
): TSetPropAtArrayPath<Rec, Path, Value>

export function setProp(
  record: any,
  path: string[] | string | null,
  value: any,
): any {
  if (path === null || (Array.isArray(path) && path.length === 0)) return value

  const pathArray = Array.isArray(path) ? path : path.split('.')

  const out = { ...record }
  let cur: Record<string | number, unknown> = out
  let i = 0
  for (; i < pathArray.length - 1; i++) {
    const key = pathArray[i]

    cur[key] = { ...(cur[key] ?? {}) }
    cur = cur[key] as Record<string | number, unknown>
  }

  cur[pathArray[i]] = value
  return out
}

export function setPropUntyped(
  record: any,
  path: string | null,
  value: any,
): unknown
export function setPropUntyped(record: any, path: string[], value: any): unknown
export function setPropUntyped(record: any, path: any, value: any): unknown {
  return setProp(record, path, value)
}

export type TSetPropAtArrayPath<
  Rec,
  Path extends string[],
  Value,
> = Path extends [infer Key, ...infer Rest]
  ? Rest extends string[]
    ? Key extends string | number
      ? (Rec extends object ? Rec : NonNullable<unknown>) & {
          [K in Key]: TSetPropAtArrayPath<
            Key extends keyof Rec ? Rec[Key] : NonNullable<unknown>,
            Rest,
            Value
          >
        }
      : never
    : never
  : Value

export type TSetPropAtStringPath<
  Rec,
  Path extends string | null,
  Value,
> = Path extends null
  ? Value
  : Path extends `${infer Key}.${infer Rest}`
  ? (Rec extends object ? Rec : NonNullable<unknown>) & {
      [K in Key]: TSetPropAtStringPath<
        Key extends keyof Rec ? Rec[Key] : NonNullable<unknown>,
        Rest,
        Value
      >
    }
  : Path extends string
  ? (Rec extends object ? Rec : NonNullable<unknown>) & { [K in Path]: Value }
  : never
